import * as React from 'react';

function SvgReconciliationPending(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FB8F23" cx={24} cy={24} r={24} />
        <path
          d="M27.217 14.143a2 2 0 012 2v5.277a7.241 7.241 0 00-7.363 10.103h-6.568a2 2 0 01-2-2v-13.38a2 2 0 012-2h11.93zm1.276 8.69a5.793 5.793 0 110 11.586 5.793 5.793 0 010-11.586zm.05 8.024a.943.943 0 100 1.886.943.943 0 000-1.886zm-.05-6.347c-.52 0-.942.388-.942.867v4.266c0 .479.422.867.942.867s.941-.388.941-.867v-4.266c0-.48-.421-.867-.941-.867zm-11.33-5.443h8.176c.542 0 .981-.39.981-.869 0-.48-.44-.869-.98-.869h-8.177c-.541 0-.98.39-.98.869 0 .48.439.869.98.869zm-.112 4.055h3.62a.869.869 0 100-1.738h-3.62a.869.869 0 100 1.738z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgReconciliationPending;
